// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iBuU","col":"styles_col__26Hka"};